// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"09d8435186f3f40db7b2","303":"826a0c0e4d7c5e1ad29f","495":"1ceb1c1e352e2116e4ba"}[chunkId] + ".js";
};